export default __webpack_public_path__ + "static/media/rabbit-blue.b8c8e602.png";